"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateEmail = exports.GetAddressURL = exports.GetDateReportURL = exports.GetStartedGameURL = exports.GetWonAtParkURL = exports.GetTimeInParksURL = exports.GetEmergencyShutdownRequestURL = exports.GetParkActivateRequestURL = exports.GetParkListURL = exports.GetAllUsersURL = exports.GetUserURL = exports.GetTransferURL = exports.GetParkURL = exports.GetClientRegistrationApproveURL = exports.GetClientRegistrationURL = exports.GetTermsAndConditionsURL = exports.GetAllClientURL = exports.GetClientURL = exports.GetParkNoteURL = exports.GetNoteURL = exports.GetParksCloseToLocationURL = exports.GetParksCloseToAddressURL = exports.GetSettingsURL = exports.yyyymmddToDate = exports.GetFirebaseConfiguration = exports.GetMapAPIKey = void 0;
const isSandbox_1 = require("./isSandbox");
function GetMapAPIKey() {
    return "AIzaSyCK07meCLb96wPd0jLIciUSNG5o56YbiSI";
}
exports.GetMapAPIKey = GetMapAPIKey;
function GetFirebaseConfiguration() {
    if (isSandbox_1.isSandbox) {
        return {
            apiKey: "AIzaSyAO7zihpU8vsgn0-tmvR50oyCg53QnzC_o",
            authDomain: "magical-park-sandbox.firebaseapp.com",
            projectId: "magical-park-sandbox",
            storageBucket: "magical-park-sandbox.appspot.com",
            messagingSenderId: "986457648595",
            appId: "1:986457648595:web:f9b633028fdc1026b7d326",
            databaseURL: "https://magical-park-sandbox-default-rtdb.firebaseio.com/",
            measurementId: "",
        };
    }
    return {
        apiKey: "AIzaSyCK07meCLb96wPd0jLIciUSNG5o56YbiSI",
        authDomain: "magical-parks.firebaseapp.com",
        databaseURL: "https://magical-parks.firebaseio.com",
        projectId: "magical-parks",
        storageBucket: "magical-parks.appspot.com",
        messagingSenderId: "751424146207",
        appId: "1:751424146207:web:81f0cf22fe8509aa813e2a",
        measurementId: "G-PM7QGC82YR",
    };
}
exports.GetFirebaseConfiguration = GetFirebaseConfiguration;
function yyyymmddToDate(dateStr) {
    const parts = dateStr.split("-");
    return new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2]));
}
exports.yyyymmddToDate = yyyymmddToDate;
function GetSettingsURL() {
    if (isSandbox_1.isSandbox) {
        return "https://magical-park-sandbox-default-rtdb.firebaseio.com/Settings.json";
    }
    return "https://magical-parks.firebaseio.com/Settings.json";
}
exports.GetSettingsURL = GetSettingsURL;
function getBaseURL() {
    if (isSandbox_1.isSandbox) {
        return "https://us-central1-magical-park-sandbox.cloudfunctions.net/API/";
    }
    return "https://us-central1-magical-parks.cloudfunctions.net/API/";
}
function GetParksCloseToAddressURL(address, lat, lng) {
    return getBaseURL() + "Park/CloseTo/" + address + "/" + lat + "/" + lng;
}
exports.GetParksCloseToAddressURL = GetParksCloseToAddressURL;
function GetParksCloseToLocationURL(lat, lng) {
    return getBaseURL() + "Park/CloseTo/" + lat + "/" + lng;
}
exports.GetParksCloseToLocationURL = GetParksCloseToLocationURL;
function GetNoteURL(client) {
    return getBaseURL() + "Note/" + client;
}
exports.GetNoteURL = GetNoteURL;
function GetParkNoteURL(park) {
    return getBaseURL() + "ParkNote/" + park;
}
exports.GetParkNoteURL = GetParkNoteURL;
function GetClientURL(client) {
    return getBaseURL() + "Client/" + client;
}
exports.GetClientURL = GetClientURL;
function GetAllClientURL() {
    return getBaseURL() + "Clients/";
}
exports.GetAllClientURL = GetAllClientURL;
function GetTermsAndConditionsURL() {
    return getBaseURL() + "TNC/";
}
exports.GetTermsAndConditionsURL = GetTermsAndConditionsURL;
function GetClientRegistrationURL(clientName = "") {
    return getBaseURL() + "ClientRegistration/" + clientName;
}
exports.GetClientRegistrationURL = GetClientRegistrationURL;
function GetClientRegistrationApproveURL(clientName) {
    return getBaseURL() + "ClientRegistration/Approve/" + clientName;
}
exports.GetClientRegistrationApproveURL = GetClientRegistrationApproveURL;
function GetParkURL(parkName = "") {
    return getBaseURL() + "ParkSite/" + parkName;
}
exports.GetParkURL = GetParkURL;
function GetTransferURL(from, to) {
    return getBaseURL() + "ParkSite/Transfer/" + from + "/" + to;
}
exports.GetTransferURL = GetTransferURL;
function GetUserURL(userUid = "") {
    return getBaseURL() + "User/" + userUid;
}
exports.GetUserURL = GetUserURL;
function GetAllUsersURL() {
    return getBaseURL() + "Users/";
}
exports.GetAllUsersURL = GetAllUsersURL;
function GetParkListURL() {
    return getBaseURL() + "Park/";
}
exports.GetParkListURL = GetParkListURL;
function GetParkActivateRequestURL(parkName) {
    return getBaseURL() + "ParkActivateRequest/" + parkName + "/";
}
exports.GetParkActivateRequestURL = GetParkActivateRequestURL;
function GetEmergencyShutdownRequestURL() {
    return getBaseURL() + "EmergencyShutdownRequest/";
}
exports.GetEmergencyShutdownRequestURL = GetEmergencyShutdownRequestURL;
function GetTimeInParksURL(startDate, endDate) {
    return getBaseURL() + "TimeInParksV2/" + startDate.replaceAll("-", "") + "/" + endDate.replaceAll("-", "");
}
exports.GetTimeInParksURL = GetTimeInParksURL;
function GetWonAtParkURL(startDate, endDate) {
    return getBaseURL() + "WonAtParkV2/" + startDate.replaceAll("-", "") + "/" + endDate.replaceAll("-", "");
}
exports.GetWonAtParkURL = GetWonAtParkURL;
function GetStartedGameURL(startDate, endDate) {
    return getBaseURL() + "StartedGame/" + startDate.replaceAll("-", "") + "/" + endDate.replaceAll("-", "");
}
exports.GetStartedGameURL = GetStartedGameURL;
function GetDateReportURL(startDate, endDate) {
    return getBaseURL() + "ReportByCouncilAndDateV2/" + startDate.replaceAll("-", "") + "/" + endDate.replaceAll("-", "");
}
exports.GetDateReportURL = GetDateReportURL;
function GetAddressURL(address) {
    return getBaseURL() + "latlng/" + address;
}
exports.GetAddressURL = GetAddressURL;
function validateEmail(email) {
    return String(email)
        .toLowerCase()
        .match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
}
exports.validateEmail = validateEmail;
